import { useSelector } from 'react-redux';
import { AccountBalance } from 'src/models';
import { Maybe } from 'src/utils';

export interface UseBalanceSelectorReturnType {
  balance: Omit<AccountBalance, 'accountId'>;
  isBalanceLoading: boolean;
  hasBalanceError: boolean;
  balanceError?: string;
}

export const useBalanceSelector = (): UseBalanceSelectorReturnType => {
  const accountBalance: Maybe<AccountBalance> = useSelector((state: any) => state.accountDetails.accountBalance?.data);
  const isBalanceLoading: boolean = useSelector((state: any) =>
    Boolean(state.accountDetails.accountBalance?.__requested),
  );
  const hasBalanceError = useSelector((state: any) => Boolean(state.accountDetails.accountBalance?.__failed));
  const balanceError: string | undefined = useSelector((state: any) => state.accountDetails.accountBalance?.__message);

  return {
    balance: {
      cashBalance: accountBalance?.cashBalance || 0,
      cashAvailable: accountBalance?.cashAvailable || 0,
      pendingOfferOrdersTotal: accountBalance?.pendingOfferOrdersTotal || 0,
      pendingExternalOfferOrdersTotal: accountBalance?.pendingExternalOfferOrdersTotal || 0,
      availableFunds: accountBalance?.availableFunds || 0,
      ordersTotal: accountBalance?.ordersTotal || 0,
      pendingTransactions: accountBalance?.pendingTransactions || 0,
    },
    isBalanceLoading,
    hasBalanceError,
    balanceError,
  };
};
